import { useMemo, useState } from "react";
import { func, bool, arrayOf, shape, string } from "prop-types";
import Modal from "@shared/v2/Modal";
import Button from "@shared/v2/Button/Button";
import Dropdown from "@shared/v2/Dropdown/Dropdown";
import Search from "@shared/v2/Icomoon/Icons/Search";
import TextLink from "@shared/v2/TextLink";
import PersonDetailsModal from "../../../../Contacts/PersonDetailsModal";
import useQuickSearch from "../../../../Dashboard/services/useQuickSearch";

const AddCoBorrowerModal = ({ modalOpen, closeModal, handleAddCoBorrower, coborrowers }) => {
  const [value, setValue] = useState(null);
  const [showModal, setshowModal] = useState(false);
  const [search, setSearch] = useState("");
  const { data: quickSearchData, loading } = useQuickSearch({ search, model: "Person" });
  const data = useMemo(
    () =>
      quickSearchData
        .filter((person) => !coborrowers.some((coBorrower) => coBorrower.uuid === person.uuid))
        .map((d) => ({
          ...d,
          value: d.objectId,
        })),
    [quickSearchData, coborrowers],
  );

  const handleAdd = () => {
    closeModal();
    handleAddCoBorrower(value);
  };

  const closeContactModal = () => {
    setshowModal(false);
  };

  const openModal = () => {
    setshowModal(true);
  };

  const handleCloseContact = (person) => {
    closeContactModal();
    if (person) {
      setValue({
        label: `${person?.firstName} ${person?.lastName}`,
        value: person?.id,
        object_type: "Person",
        slug: person?.slug,
        object_id: person?.id,
        uuid: person?.uuid,
      });
    }
  };
  return (
    <>
      <Modal
        className="tw-flex tw-justify-center tw-items-center"
        contentClassName="tw-max-w-[510px] tw-flex tw-flex-col tw-gap-[32px]"
        show={modalOpen}
        onHide={closeModal}
      >
        <Modal.Header closeButton title="Add a Co-Borrower" />
        <Modal.Body className="tw-flex-1 tw-flex tw-flex-col tw-gap-[16px]">
          <Dropdown
            label="Select a co-borrower associated with the loan."
            placeholder="Search by contact name, email, or phone "
            isRequired
            isSearchable
            isLoading={loading}
            onInputChange={setSearch}
            onChange={setValue}
            value={value}
            options={data}
            menuShouldComeToFront
            shouldFilterOptions={false}
            inputTrailing={<Search size="l" style={{ verticalAlign: "middle" }} />}
            helperText={
              <>
                Don’t have the co-borrower as a contact in your CRM?{" "}
                <TextLink className="tw-text-12d" onClick={openModal}>
                  Add them here
                </TextLink>
              </>
            }
          />
        </Modal.Body>
        <Modal.Footer className="tw-flex tw-gap-[12px] tw-justify-between">
          <Button size="medium" schema="tertiary" onClick={closeModal}>
            Cancel
          </Button>
          <Button size="medium" type="submit" onClick={handleAdd} disabled={!value}>
            Add
          </Button>
        </Modal.Footer>
      </Modal>

      <PersonDetailsModal showAddDetailsButton={false} show={showModal} onClose={handleCloseContact} />
    </>
  );
};

AddCoBorrowerModal.propTypes = {
  modalOpen: bool,
  closeModal: func,
  handleAddCoBorrower: func,
  coborrowers: arrayOf(
    shape({
      id: string,
      full_name: string,
    }),
  ),
};

AddCoBorrowerModal.defaultProps = {
  modalOpen: false,
  closeModal: () => {},
  handleAddCoBorrower: () => {},
  coborrowers: [],
};

export default AddCoBorrowerModal;
